import {clientPostBlobWrapper} from "../api/Api";
import {CORRECT_CONVERSIONS_CSV_EXPORT_EXCEL} from "../common/constants/routes";

export const correctAndExportCSV = (formData) => {
    return clientPostBlobWrapper(CORRECT_CONVERSIONS_CSV_EXPORT_EXCEL, formData,true);
}